import route from 'ziggy-js'

const propsDef = {
  routeName: {
    type: String,
    required: false,
  },
  href: {
    type: String,
    required: false,
  },
  routeParams: {
    type: Object,
    required: false,
    default: () => {
      return {}
    },
  },
  routeQueryString: {
    type: String,
    required: false,
  },
  routeHash: {
    type: String,
    required: false,
  },
  disable: {
    type: Boolean,
    required: false,
    default: false,
  },
  color: {
    type: String,
    required: false,
    default: () => {
      return 'white'
    },
  },
  textColor: {
    type: String,
    required: false,
    default: () => {
      return 'black'
    },
  },
}

const computeHref = (props) => {
  if (props.routeName) {
    const url = new URL(route(props.routeName, props.routeParams))
    if (props.routeQueryString) {
      const query = new URLSearchParams(props.routeQueryString)
      query.forEach((key, value) => url.searchParams.append(key, value))
    }
    if (props.routeHash) {
      url.hash = props.routeHash
    }

    return url.toString()
  }

  return props.href
}

const computeUrl = (props) => props.disable ? null : computeHref(props)

export {
  propsDef,
  computeUrl,
}
